export default __webpack_public_path__ + "img/tremors/tremors2_1500.jpg";